import { render, staticRenderFns } from "./TradeKanban.vue?vue&type=template&id=13e97418&"
import script from "./TradeKanban.vue?vue&type=script&lang=js&"
export * from "./TradeKanban.vue?vue&type=script&lang=js&"
import style0 from "./TradeKanban.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports